/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
//
// THIS IS A GENERATED FILE
// DO NOT MODIFY IT! YOUR CHANGES WILL BE LOST
import { Inject, Injectable, Optional } from '@angular/core';
import {
  GrpcCallType,
  GrpcClient,
  GrpcClientFactory,
  GrpcEvent,
  GrpcMetadata
} from '@ngx-grpc/common';
import {
  GRPC_CLIENT_FACTORY,
  GrpcHandler,
  takeMessages,
  throwStatusErrors
} from '@ngx-grpc/core';
import { Observable } from 'rxjs';
import * as thisProto from './config-service.pb';
import * as shared000 from '../../../../src/main/proto/shared/config-shared.pb';
import { GRPC_CONFIG_SERVICE_CLIENT_SETTINGS } from './config-service.pbconf';
/**
 * Service client implementation for api.config.ConfigService
 */
@Injectable({ providedIn: 'any' })
export class ConfigServiceClient {
  private client: GrpcClient<any>;

  /**
   * Raw RPC implementation for each service client method.
   * The raw methods provide more control on the incoming data and events. E.g. they can be useful to read status `OK` metadata.
   * Attention: these methods do not throw errors when non-zero status codes are received.
   */
  $raw = {
    /**
     * Unary call: /api.config.ConfigService/GetConfig
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.GetConfigResponse>>
     */
    getConfig: (
      requestData: thisProto.GetConfigRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.GetConfigResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/api.config.ConfigService/GetConfig',
        requestData,
        requestMetadata,
        requestClass: thisProto.GetConfigRequest,
        responseClass: thisProto.GetConfigResponse
      });
    },
    /**
     * Unary call: /api.config.ConfigService/UpdateConfig
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.UpdateConfigResponse>>
     */
    updateConfig: (
      requestData: thisProto.UpdateConfigRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.UpdateConfigResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/api.config.ConfigService/UpdateConfig',
        requestData,
        requestMetadata,
        requestClass: thisProto.UpdateConfigRequest,
        responseClass: thisProto.UpdateConfigResponse
      });
    }
  };

  constructor(
    @Optional() @Inject(GRPC_CONFIG_SERVICE_CLIENT_SETTINGS) settings: any,
    @Inject(GRPC_CLIENT_FACTORY) clientFactory: GrpcClientFactory<any>,
    private handler: GrpcHandler
  ) {
    this.client = clientFactory.createClient(
      'api.config.ConfigService',
      settings
    );
  }

  /**
   * Unary call @/api.config.ConfigService/GetConfig
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.GetConfigResponse>
   */
  getConfig(
    requestData: thisProto.GetConfigRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.GetConfigResponse> {
    return this.$raw
      .getConfig(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/api.config.ConfigService/UpdateConfig
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.UpdateConfigResponse>
   */
  updateConfig(
    requestData: thisProto.UpdateConfigRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.UpdateConfigResponse> {
    return this.$raw
      .updateConfig(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }
}
